<div class="cards-on-file-toolbar">
	<h4 class="cards-on-file-title">Cards On File</h4>
	<div class="cards-on-file-toolbar-actions">
		<span *ngIf="loadingcards" class="cards-on-file-spinner-wrap">
			<svg class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</span>
		<button type="button" class="btn btn-sm btn-primary" (click)="toggleAddCard()">
			<i class="fa fa-plus"></i>&nbsp;&nbsp;New Card
		</button>
	</div>
</div>

<app-credit-card-form
	*ngIf="addCardFormEverOpened && customer?.debtorno"
	[hidden]="!addingcard"
	[customer]="customer"
	[branches]="customer.branches"
	[type]="'orderentry'"
	(updatePayments)="loadProfile()"></app-credit-card-form>
<ng-container *ngIf="!addingcard">
	<mat-card class="cards-on-file-panel">
		<mat-card-content class="cards-on-file-panel-content">
			<ul class="list-group cards-on-file-list">
				<li class="list-group-item text-center cards-on-file-empty" *ngIf="profile_cards && !profile_cards.length && !loadingcards">
					<mat-icon color="primary">credit_card</mat-icon>
					<span>No Cards On File</span>
				</li>
				<li class="list-group-item card-item" *ngFor="let c of profile_cards; let i = index;">
					<div class="card-item-inner">
						<div class="card-item-main">
							<button type="button" mat-icon-button class="card-default-toggle"
								[matTooltip]="c.default ? 'Default payment card' : 'Set as default'"
								[attr.aria-label]="c.default ? 'Default card' : 'Set as default card'"
								[disabled]="settingdefault || loadingcards"
								(click)="setAsDefault(c)">
								<mat-icon *ngIf="c.default" class="default-icon">star</mat-icon>
								<mat-icon *ngIf="!c.default" class="not-default-icon">star_border</mat-icon>
							</button>
							<div class="card-item-text">
								<div class="card-item-row">
									<span class="card-brand">{{ c.card_type }}</span>
									<span class="card-dot" aria-hidden="true">·</span>
									<span class="card-pan">•••• {{ lastFour(c) }}</span>
									<span class="card-dot" aria-hidden="true">·</span>
									<span class="card-expiry"><span class="card-expiry-label">Exp</span> {{ c.expiry_month }}/{{ c.expiry_year }}</span>
									<ng-container *ngIf="c.name || showCardBranch(c)">
										<span class="card-dot" aria-hidden="true">·</span>
										<span *ngIf="showCardBranch(c)" class="card-branch">{{ c.branchcode }}</span>
										<span *ngIf="showCardBranch(c) && c.name" class="card-dot" aria-hidden="true">·</span>
										<span *ngIf="c.name" class="card-holder">{{ c.name }}</span>
									</ng-container>
								</div>
							</div>
						</div>
						<button type="button" mat-icon-button color="warn" class="remove-button"
							matTooltip="Remove card"
							aria-label="Remove card from profile"
							(click)="removeCard(c)">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</li>
			</ul>
		</mat-card-content>
	</mat-card>
</ng-container>